'use strict'
import BaseService from './baseService'

export default class GenusService extends BaseService {
  getGenusDetailsByUUID (genusUUID) {
    if (!genusUUID) throw new Error('Genus uuid is required.')

    return this.glossaryDBInformation[genusUUID] || null
  }

  getRelatedSpeciesDetailsForGivenGenus (genusUUID) {
    if (!genusUUID) throw new Error('Genus uuid is required.')

    const sampleData = Object.values(this.abundanceData) || []
    return sampleData.filter(species => species.currentSpecieRelatedGenusUUID === genusUUID) || []
  }
}
